export const homePage = "/";
export const loginHomePage = "/login";
export const registrationHomePage = "/signup";
